import { configureStore } from "@reduxjs/toolkit";
import LiveOrderAction from "./Reducers/LiveOrder-Reducer";
const store = configureStore({
  reducer: {
    liveOrder: LiveOrderAction,
  },
});

export default store;
